import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { RoutePath } from '../enum/common-enum';

export const registerGuard: CanActivateFn = (route, state) => {
  const storageService = inject(StorageService);
  const router = inject(Router);
  const url = state.url;
  const registerId = storageService.retrieve('REGISTER_ID');
    const restrictedPaths:any = [RoutePath.WhatsappCampaign, RoutePath.WhatsappReport, RoutePath.Inbox];
  if (!restrictedPaths.includes(url)  && registerId) {
  router.navigateByUrl('/account/login');
  return false;
}
 if (restrictedPaths.includes(url) && !registerId) {
  router.navigateByUrl('/account/login');
  return false;
}
  return true;
};
